import React from 'react';
import PropTypes from 'prop-types';
import { AuthConsumer } from './AuthContext';
import { Redirect, Route } from 'react-router-dom';

export default function AuthRoute({ component: Component, roles, ...rest }) {
  return (
    <AuthConsumer>
      {auth => (
        <Route
          render={props =>
            auth.isAuthorized(roles) ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: '/pages/login',
                  // state: { from: props.location },
                }}
              />
            )
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  );
}

AuthRoute.defaultProps = {
  roles: [],
};

AuthRoute.propTypes = {
  roles: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/auth/AuthRoute.jsx